import { render, staticRenderFns } from "./BatchRecieveServerTable.vue?vue&type=template&id=38031a3b"
import script from "./BatchRecieveServerTable.vue?vue&type=script&lang=js"
export * from "./BatchRecieveServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports